export const LiveCaptions = ({ captions, me }) => {
  const list = Object.entries(captions).filter(([, c]) => c.text);
  if (!list.length) return null;
  return (
    <div className="space-y-2 border-t border-border bg-background/60 px-4 py-3 backdrop-blur-xl sm:px-8" data-testid="room-live-captions">
      {list.map(([uid, c]) => (
        <div key={uid} className="fade-up flex items-start gap-3" data-testid={`live-caption-${uid}`}>
          <span className="mt-0.5 shrink-0 font-mono text-[10px] tracking-widest text-muted-foreground">
            <span className={c.stage === "live" ? "animate-pulse text-[color:var(--au-red)]" : "text-[color:var(--au-cyan)]"}>●</span>{" "}
            {uid === me ? "YOU" : c.name?.toUpperCase()} [{c.language?.toUpperCase()}] · {c.stage === "live" ? "LIVE" : "TRANSLATING"}
          </span>
          <p className="min-w-0 flex-1 text-sm italic text-muted-foreground" data-testid="live-caption-text">{c.text}</p>
        </div>
      ))}
    </div>
  );
};
